import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, Rocket, Lightbulb, Gift, Target, XCircle, Zap, Download, ShieldCheck } from 'lucide-react';
export function PremiumProduct() {
  const learnings = ['Cómo encontrar proveedores confiables en China sin cometer errores', 'Cómo negociar precios y reducir costos desde el inicio', 'Cómo crear tu nombre de marca y logo profesional', 'Cómo personalizar tu producto para diferenciarte', 'Cómo lanzar una marca que se vea confiable y lista para vender'];
  const brandBenefits = ['Puedes cobrar más', 'Te diferencias fácilmente', 'Generas confianza', 'Construyes algo que puede crecer'];
  const bonuses = ['Lista privada de proveedores verificados en China', 'Plantillas de negociación estratégica con proveedores', 'Kit completo para crear tu branding profesional'];
  const results = ['Vas a poder crear tu propia marca desde cero', 'Vas a entender cómo trabajar con proveedores reales', 'Vas a dar el paso de vender… a construir un negocio'];
  return <section className="bg-white py-24 px-6" data-id="element-265">
      <div className="max-w-4xl mx-auto" data-id="element-266">
        {/* Header */}
        <FadeIn data-id="element-267">
          <div className="text-center mb-16" data-id="element-268">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-green/10 rounded-full mb-6" data-id="element-269">
              <Rocket className="w-8 h-8 text-brand-green" data-id="element-270" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green mb-10" data-id="element-271">
              CREA TU MARCA EN AMAZON DESDE CHINA
            </h2>

            {/* Product Image */}
            <div className="mb-10 px-4" data-id="element-272">
              <img src="https://cdn.magicpatterns.com/uploads/wkmAtza51kc25BvybjSw4U/portada.png" alt="Crea tu Marca en Amazon desde China - Guía Premium" className="w-full max-w-2xl mx-auto h-auto rounded-2xl shadow-2xl object-contain" data-id="element-273" />
            </div>

            <p className="text-lg md:text-xl text-brand-text/70 leading-relaxed mb-6" data-id="element-274">
              Aprende cómo pasar de vender productos genéricos a construir una
              marca propia con proveedores verificables y crear un negocio real
              que puedas escalar.
            </p>

            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-275">
              <Rocket className="w-5 h-5 text-brand-gold" data-id="element-276" />
              <p className="text-xl md:text-2xl font-serif text-brand-green font-semibold" data-id="element-277">
                ESTE ES EL SIGUIENTE NIVEL
              </p>
            </div>
            <p className="text-lg text-brand-text/60" data-id="element-278">
              Aquí es donde dejas de competir por precio… y empiezas a construir
              algo que realmente te pertenece.
            </p>

            <div className="mt-10" data-id="element-279">
              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/crea-tu-marca-en-amazon-desde-china', '_blank')} className="w-full sm:w-auto text-lg md:text-xl px-14 py-5" data-id="element-280">
                QUIERO EMPEZAR A CREAR MI MARCA
              </Button>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-281">
                <span className="flex items-center gap-1.5" data-id="element-282">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-283" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-284">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-285" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-286">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-287" />
                  COMPRA SEGURA
                </span>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Lo que aprenderás */}
        <FadeIn delay={0.1} data-id="element-288">
          <div className="bg-brand-beige rounded-2xl p-8 md:p-10 mb-10" data-id="element-289">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-290">
              <Lightbulb className="w-6 h-6 text-brand-gold" data-id="element-291" />
              <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-292">
                LO QUE VES AQUÍ NO ES SOLO UNA GUÍA
              </h3>
            </div>
            <p className="text-center text-brand-text/60 mb-6" data-id="element-293">
              Es el sistema que te enseña a:
            </p>
            <div className="space-y-4 max-w-xl mx-auto" data-id="element-294">
              <div className="flex items-start gap-3" data-id="element-295">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-296" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-297">
                  Crear una marca desde cero
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-298">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-299" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-300">
                  Trabajar con proveedores reales en China
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-301">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-302" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-303">
                  Diferenciarte de la competencia
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-304">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-305" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-306">
                  Construir un negocio que pueda crecer
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Lo que aprenderás en la guía premium */}
        <FadeIn delay={0.15} data-id="element-307">
          <div className="bg-brand-beige rounded-2xl p-8 md:p-10 mb-10" data-id="element-308">
            <div className="flex items-center gap-3 mb-6" data-id="element-309">
              <Rocket className="w-6 h-6 text-brand-gold" data-id="element-310" />
              <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-311">
                LO QUE APRENDERÁS EN ESTA GUÍA PREMIUM
              </h3>
            </div>
            <div className="space-y-4" data-id="element-312">
              {learnings.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-313">
                  <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-314" />
                  <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-315">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Por qué este nivel cambia todo */}
        <FadeIn delay={0.2} data-id="element-316">
          <div className="text-center mb-10" data-id="element-317">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-318">
              <Lightbulb className="w-6 h-6 text-brand-gold" data-id="element-319" />
              <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-320">
                POR QUÉ ESTE NIVEL CAMBIA TODO
              </h3>
            </div>
            <p className="text-lg text-brand-text/70 mb-2" data-id="element-321">
              Muchas personas logran vender en Amazon…
            </p>
            <p className="text-lg text-brand-text/70 mb-8" data-id="element-322">
              Pero pocas crean una marca.
            </p>
            <p className="text-lg text-brand-text/60 mb-8" data-id="element-323">
              Y ahí es donde está la diferencia entre:
            </p>

            {/* Comparison */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-10" data-id="element-324">
              <div className="bg-red-50 border border-red-100 rounded-xl px-6 py-4 flex items-center gap-3" data-id="element-325">
                <XCircle className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-326" />
                <span className="text-brand-text/70 font-medium" data-id="element-327">
                  Vender productos genéricos
                </span>
              </div>
              <span className="text-brand-text/30 font-bold text-lg" data-id="element-328">VS</span>
              <div className="bg-green-50 border border-green-200 rounded-xl px-6 py-4 flex items-center gap-3" data-id="element-329">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-330" />
                <span className="text-brand-green font-semibold" data-id="element-331">
                  Construir un negocio real con identidad propia
                </span>
              </div>
            </div>

            <p className="text-lg text-brand-text/70 mb-6" data-id="element-332">
              Cuando tienes tu marca:
            </p>
            <div className="inline-flex flex-col items-start gap-3 text-left" data-id="element-333">
              {brandBenefits.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-334">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-335" />
                  <span className="text-lg text-brand-text font-medium" data-id="element-336">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Resultado Final */}
        <FadeIn delay={0.4} data-id="element-337">
          <div className="text-center" data-id="element-338">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-339">
              <Target className="w-6 h-6 text-brand-gold" data-id="element-340" />
              <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-341">
                RESULTADO FINAL
              </h3>
            </div>
            <p className="text-lg text-brand-text/70 mb-8" data-id="element-342">
              Con esta guía no solo aprenderás…
            </p>
            <div className="inline-flex flex-col items-start gap-4 text-left" data-id="element-343">
              {results.map((item, index) => <p key={index} className="text-lg md:text-xl text-brand-green font-semibold flex items-center gap-3" data-id="element-344">
                  <span data-id="element-345">👉</span> {item}
                </p>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}